import { DataType, IValidationError } from 'flux-definition';
import { AbstractDataItem } from './data-item-abstract';

/**
 * This does validation of child shape data items.
 * For the moment no validation is required.
 */
export class ChildShapeDataItem extends AbstractDataItem<DataType.CHILD_SHAPE> {
    /**
     * Checks whether the given value is valid (returns the error if any)
     */
    public validate( value: typeof ChildShapeDataItem.prototype.value ): IValidationError {
        return null;
    }
}
